// extracted by mini-css-extract-plugin
export var duration = "index-module--duration--4K2OW";
export var playBtn = "index-module--playBtn--3esag";
export var playBtnWrapper = "index-module--playBtnWrapper--4D32Q";
export var videoBtnWrapper = "index-module--videoBtnWrapper--w1irh";